import Image from "@Components/Image";
import styles from "./SalesOfferSection.module.scss";
import { useAmberSales } from "hooks/useAmberSales";
import config from "@Config/index";
import wrapperHOC from "@Utils/wrapperHOC";

const SalesOfferSection = ({ inventoryMeta }: any) => {
  const {
    isSaleOfferAvailableOnInventory,
    salesOfferTextForInventory,
    inventoryBrandImage,
    backgroundGradient,
  }: any = useAmberSales({
    inventoryMeta,
    page: "PROPERTY",
  });

  if (!isSaleOfferAvailableOnInventory) return <></>;

  return (
    <div className={styles.saleOfferContainer}>
      <Image
        src={`${config.IMAGE_STATIC_URL}/images/waves.svg`}
        alt="image2"
        height="auto"
        width="100%"
        isEagerLoad
        className={styles.bgImage}
      />
      <div className={styles.imageContainer} style={{ background: backgroundGradient }}>
        <Image
          src={inventoryBrandImage}
          alt="sale-offer-banner"
          width={150}
          height="auto"
          isEagerLoad
        />
      </div>
      <div className={styles.divider} />
      <p className={styles.saleOfferText}>{salesOfferTextForInventory}</p>
    </div>
  );
};

export default wrapperHOC(SalesOfferSection, {
  componentName: "SalesOfferSection",
  showForChina: true,
});
